import KnowledgeBase from './KnowledgeBase'

const Home = () => {
    return <KnowledgeBase />
}

export default Home
